export const MaxxBelekSports = {
    title: 'Maxx Royal Belek',
    logo: {
      src: 'MaxxBelek.png',
      height: '40',
    },
    languages: [
        {
            id: 1,
            lang: "TR",
            langNative: "Türkçe",
        }, {
            id: 2,
            lang: "EN",
            langNative: "English",
        }, {
            id: 3,
            lang: "DE",
            langNative: "Deutsch",
        }, {
            id: 4,
            lang: "RU",
            langNative: "Русский",
        }
    ],
    menu: [
        {
            id: 'sports',
            key: 'room_information',
            icon: 'infobook',
            link: {
                url: '/info/sports',
                target: '_self'
            },
            detail: {
                tr: 'https://drive.google.com/file/d/1cWaCdyhLSRyk3TVCXQ_9jy9ZRlTGv7_A/preview',
                en: 'https://drive.google.com/file/d/1SYsqrWo-aLjqGVwdJqY2WjqwU26rv3cS/preview',
                ru: 'https://drive.google.com/file/d/19TmYAICh5N4n36pTAh7Ame8PlZrjB-ea/preview',
                de: 'https://drive.google.com/file/d/1ZVlIoExyQMwodSWafCue1UldgXYZfjf5/preview',
            }
        },
    ]
}
